export default "__VITE_ASSET__BrBh08ex__"